import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-kcgl",
  "use": "icon-kcgl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-kcgl\"><path d=\"M512 122.176l423.509333 266.752-34.112 54.144-58.752-37.013333L842.666667 906.666667h-661.333334l-0.021333-500.608-58.709333 37.013333-34.112-54.144L512 122.176z m0 75.648l-266.688 167.936L245.333333 842.666667h533.333334l-0.021334-476.928L512 197.824z m150.4 454.592v64H363.306667v-64H662.4z m0-170.666667v64H363.306667v-64H662.4z\" fill=\"#ffffff\" p-id=\"3412\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol